import React from 'react';
import { tastics } from 'frontastic/tastics';
import { TasticWrapperProps } from './types';
import { injectDataSources } from '../../utils/inject-datasources';
import MissingTastic from '../missing-tastic';

const TasticWrapper = ({ data, params, searchParams, dataSources, isHighlighted, categories }: TasticWrapperProps) => {
  const Tastic = tastics[data.tasticType];
  const fullScreenTastics = [
    'commercetools/ui/footer',
    'commercetools/ui/header',
    'sol/ui/checkout-header',
    'sol/ui/checkout-footer',
  ];

  const resolvedTasticData = dataSources ? injectDataSources(data.configuration, dataSources) : data.configuration;

  return (
    <div
      id={data?.tasticId}
      className={`${fullScreenTastics.includes(data?.tasticType) ? '' : 'px-4 lg:mx-auto lg:max-w-[--page-max-width]'}`}
    >
      {Tastic ? (
        <Tastic data={resolvedTasticData} params={params} searchParams={searchParams} categories={categories} />
      ) : (
        <MissingTastic data={data} />
      )}
    </div>
  );
};

export default TasticWrapper;
